import { List } from "basis";

export const ImportantInformationList = () => (
  <List>
    <List.Item>
      If you want to increase your credit limit down the track, you may not be
      able to. You will need to go through an assessment and may need to supply
      documentation to evidence your income.
    </List.Item>
    <List.Item>
      We can’t reduce your credit limit lower than the balance on the account.
    </List.Item>
  </List>
);
